<template>
  <div :class="$style.bindPhone">
    <header>
      <i class="iconfont yw-xiangzuo" @click="$emit('close')" />
      <span>{{ type === 'bind' ? '绑定手机' : '解绑手机' }}</span>
      <img :src="`${this.$cdnLink}/suspend/tongyong/guanbi.png`" alt @click="$emit('closePage')" :class="$style.closePage" />
    </header>
    <div :class="$style.inputWrap">
      <img :src="`${this.$cdnLink}/suspend/mine/phone.png`" alt />
      <input type="text" v-model.trim="phone" placeholder="请输入手机号" />
    </div>
    <div :class="$style.inputWrap">
      <img :src="`${this.$cdnLink}/suspend/mine/code.png`" />
      <input type="text" v-model.trim="code" placeholder="请输入验证码" />
      <span v-if="timer">{{ count }}S</span>
      <span v-else :class="$style.retry" @click="getCode">发送验证</span>
    </div>
    <button :class="$style.submit" @click="bindPhone">提交</button>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { regexpVerify } from '@/libs/business/account';
import { getSmsCode, bindTel, unbundlingTel } from '@/api/user';
import { batchSetStorage } from '@/libs/utils';

export default {
  data() {
    return {
      phone: '',
      code: '',
      count: '',
      timer: null,
    };
  },
  computed: {
    ...mapState({
      userState: (state) => state.user,
    }),
    type() {
      // bind 绑定 unbind 解绑
      return this.$store.state.user.tel_status == 1 ? 'unbundling' : 'bind';
    },
  },
  methods: {
    ...mapMutations({
      showLoading: 'global/showLoading',
      changeUserState: 'user/CHANGE_STATE',
    }),
    async getCode() {
      await regexpVerify({ phone: this.phone }, [{ key: 'phone', hint: '请输入正确的手机号', type: 'phone' }]);
      const { appkey } = this.userState;
      this.setTimer();
      try {
        await getSmsCode({
          jh_app_id: appkey,
          tel_num: this.phone,
          type: this.type,
        });
        this.$toast('发送成功');
      } catch (error) {
        this.clearTimer();
      }
    },
    setTimer() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    clearTimer() {
      this.count = '';
      clearInterval(this.timer);
      this.timer = null;
    },
    async bindPhone() {
      await regexpVerify({ phone: this.phone, code: this.code }, [
        { key: 'phone', hint: '请输入正确的手机号', type: 'phone' },
        { key: 'code', hint: '请输入验证码' },
      ]);
      const { username, user_id, access_token, appkey } = this.userState;
      let params = {
        tel_num: this.phone,
        code: this.code,
        user_name: username,
        user_id: user_id,
        access_token: access_token,
        appkey: appkey,
      };
      this.showLoading();
      if (this.type === 'bind') {
        const r = await bindTel(params);
        this.$toast('绑定成功');
        this.changeUserState({ tel_num: this.phone, tel_status: 1 });
        // 原生包添加缓存
        batchSetStorage({ tel_status: 1, tel_num: this.phone });
        this.$store.commit('suspend/SET_TAB_HINT', {
          tabType: 'geren',
          hintType: false,
        });
      } else {
        const r = await unbundlingTel(params);
        this.$toast('解绑成功');
        this.changeUserState({ tel_num: '', tel_status: 0 });
        // 原生包添加缓存
        batchSetStorage({ tel_status: 0, tel_num: '' });
      }
      this.phone = '';
      this.code = '';
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" module>
.bindPhone {
  background: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  > header {
    position: relative;
    font-size: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    height: 40px;
    padding: 0 15px;
    color: #7a7979;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 40px;
    :global {
      .yw-xiangzuo {
        width: 15px;
        height: 15px;
        color: #7a7979;
      }
    }
    .closePage {
      height: 13px;
    }
  }
  .inputWrap {
    position: relative;
    display: flex;
    border-bottom: 1px solid #ebebeb;
    margin: 0 22px 12px;
    padding: 6px 9px;
    > img {
      width: 13px;
      height: 15px;
      margin-right: 14px;
    }
    > input {
      border: none;
      font-size: 15px;
    }
    > span {
      position: absolute;
      right: 10px;
      width: 50px;
      text-align: center;
      border: none;
      font-size: 11px;
      color: #999999;
    }
    .retry {
      color: #ff5b58;
    }
  }
  .submit {
    margin: 54px auto 0;
    width: 293px;
    height: 41px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 15px;
    border: none;
    outline: none;
    background: #ff5b58;
    border-radius: 20px;
  }
}
</style>
